var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGraphicDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150.05 112.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: -23.4,
    x2: 94.25,
    y1: 33.32,
    y2: 128.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#315050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42ACA5"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -40.79,
    x2: 76.85,
    xlinkHref: "#a",
    y1: 54.73,
    y2: 150.32
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -37.97,
    x2: 79.68,
    xlinkHref: "#a",
    y1: 51.25,
    y2: 146.84
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -33.93,
    x2: 83.72,
    xlinkHref: "#a",
    y1: 46.27,
    y2: 141.86
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -31.1,
    x2: 86.55,
    xlinkHref: "#a",
    y1: 42.8,
    y2: 138.38
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -27.06,
    x2: 90.59,
    xlinkHref: "#a",
    y1: 37.82,
    y2: 133.41
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -24.23,
    x2: 93.42,
    xlinkHref: "#a",
    y1: 34.34,
    y2: 129.93
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -20.19,
    x2: 97.46,
    xlinkHref: "#a",
    y1: 29.37,
    y2: 124.96
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -17.36,
    x2: 100.28,
    xlinkHref: "#a",
    y1: 25.89,
    y2: 121.48
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -13.32,
    x2: 104.33,
    xlinkHref: "#a",
    y1: 20.92,
    y2: 116.5
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: -10.5,
    x2: 107.15,
    xlinkHref: "#a",
    y1: 17.44,
    y2: 113.03
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -6.45,
    x2: 111.19,
    xlinkHref: "#a",
    y1: 12.46,
    y2: 108.05
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: -19.96,
    x2: 97.68,
    xlinkHref: "#a",
    y1: 29.09,
    y2: 124.68
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -4.1,
    x2: 113.55,
    xlinkHref: "#a",
    y1: 9.56,
    y2: 105.15
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: -1.64,
    x2: 116.01,
    xlinkHref: "#a",
    y1: 6.54,
    y2: 102.13
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 19.71,
    x2: 137.36,
    xlinkHref: "#a",
    y1: -19.74,
    y2: 75.85
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 14.07,
    x2: 131.72,
    xlinkHref: "#a",
    y1: -12.8,
    y2: 82.79
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: -33.95,
    x2: 83.69,
    xlinkHref: "#a",
    y1: 46.31,
    y2: 141.9
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 10.97,
    x2: 128.62,
    xlinkHref: "#a",
    y1: -8.98,
    y2: 86.61
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: -16.76,
    x2: 100.89,
    xlinkHref: "#a",
    y1: 25.14,
    y2: 120.73
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -31.95,
    x2: 85.7,
    xlinkHref: "#a",
    y1: 43.84,
    y2: 139.43
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: -0.07,
    x2: 117.57,
    xlinkHref: "#a",
    y1: 4.61,
    y2: 100.2
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: -3.57,
    x2: 114.07,
    xlinkHref: "#a",
    y1: 8.92,
    y2: 104.51
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: -26.57,
    x2: 91.07,
    xlinkHref: "#a",
    y1: 37.23,
    y2: 132.81
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h150.05v112.2h-150.05z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m95 99.82h-55.27v-4h45.6l-16.21-16.21 2.88-2.83zm-61.38 0h-33.62v-95l21.66 21.67-2.83 2.83-14.83-14.83v81.33h29.61zm14.38-16.25h-31.75v-34.69h4v30.69h27.75z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m2 90.42h7.2v4h-7.2z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m2 83.4h4.14v4h-4.14z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m2 76.39h7.2v4h-7.2z",
    fill: "url(#d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m2 69.37h4.14v4h-4.14z",
    fill: "url(#e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m2 62.35h7.2v4h-7.2z",
    fill: "url(#f)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m2 55.34h4.14v4h-4.14z",
    fill: "url(#g)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m2 48.32h7.2v4h-7.2z",
    fill: "url(#h)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m2 41.3h4.14v4h-4.14z",
    fill: "url(#i)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m2 34.29h7.2v4h-7.2z",
    fill: "url(#j)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m2 27.27h4.14v4h-4.14z",
    fill: "url(#k)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m2 20.26h7.2v4h-7.2z",
    fill: "url(#l)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m59.19 105.85-8.35-15.36v-2.74h4v1.72l4.35 8.01 4.36-8.01v-1.72h4v2.74z",
    fill: "url(#m)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m68.19 91.51h-17.99v-61.05h4v57.05h9.99v-57.05h4z",
    fill: "url(#n)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m57.19 28.89h4v54.15h-4z",
    fill: "url(#o)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m67.56 14.65h-4v-2.34h-8.73v2.34h-4v-3.2a3 3 0 0 1 .9-2.13 3.55 3.55 0 0 1 2.5-1h9.93a3.29 3.29 0 0 1 3.4 3.14z",
    fill: "url(#p)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m68.19 30.76h-18v-13.76h18zm-14-4h10v-5.76h-10z",
    fill: "url(#q)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m35.11 100.74h4v6.62h-4z",
    fill: "url(#r)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m43.92 16.07h-4v-3.76h-5.8v3.76h-4v-7.76h13.8z",
    fill: "url(#s)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m29.91 83.74v-29.84h4v25.84h6.17v-25.84h4v29.84z",
    fill: "url(#t)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m41.87 103.59h-9.74v-7.47h4v3.47h1.74v-3.47h4z",
    fill: "url(#u)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m45.2 55.15h-16.35v-40.8h16.35zm-12.35-4h8.35v-32.8h-8.35z",
    fill: "url(#v)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m22.86 55.42-.01-33.55h20.32v4h-16.32l.01 29.55z",
    fill: "url(#w)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m30.55 97.81v-17.81h12.89v17.81zm4-13.86v9.86h4.89v-9.81z",
    fill: "url(#x)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraphicDesign);
export default __webpack_public_path__ + "static/media/icon_graphic-design.f9f9f092ec4da69ab249a11a417904ea.svg";
export { ForwardRef as ReactComponent };